<script lang="ts">
  interface Props {
    size?: number;
  }

  let { size = 50 }: Props = $props();
</script>

<div class="comp-custom-spinner" style="height: {size}px;">
  <div class="spinner">
    <div class="loader" style="width: {size}px; height: {size}px;">
      <svg
        class="circular-loader"
        viewBox="25 25 50 50"
        style="width: {size}px; height: {size}px;"
      >
        <circle
          class="loader-path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke="#35BC98"
          stroke-width="4"
        />
      </svg>
    </div>
  </div>
</div>

<style>
  .comp-custom-spinner {
    position: relative;
    height: 100%;
  }

  .spinner .loader {
    position: relative;
    margin: 0px auto;
  }

  .spinner .loader:before {
    content: '';
    display: block;
    padding-top: 100%;
  }

  .circular-loader {
    -webkit-animation: rotate 2s linear infinite;
    animation: rotate 2s linear infinite;
    -webkit-transform-origin: center center;
    -ms-transform-origin: center center;
    transform-origin: center center;
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
  }

  .loader-path {
    stroke-dasharray: 150, 200;
    stroke-dashoffset: -10;
    -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
  }

  @-webkit-keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
  @-webkit-keyframes color {
    0% {
      stroke: #70c542;
    }
    40% {
      stroke: #70c542;
    }
    66% {
      stroke: #35bc98;
    }
    80%,
    90% {
      stroke: #35bc98;
    }
  }
  @keyframes color {
    0% {
      stroke: #35bc98;
    }
    40% {
      stroke: #35bc98;
    }
    66% {
      stroke: #35bc98;
    }
    80%,
    90% {
      stroke: #35bc98;
    }
  }
</style>